import { Media } from '@form-builder/types'
import { ColumnProps } from 'antd/es/table'
import { Image } from 'iconsax-react'

import { checkImageURL } from '../utils'

import { useStyles } from './styles'

export const GetTableColumns = () => {
  const { styles } = useStyles()
  const columns: ColumnProps<Media>[] = [
    {
      title: 'Preview',
      dataIndex: 'url',
      render: (_, item) => {
        const isImage = checkImageURL(item.url)

        return (
          <>
            {isImage ? (
              <img src={item.url} alt={item.name} className={styles.image} />
            ) : (
              <Image />
            )}
          </>
        )
      }
    },
    {
      title: 'Name',
      dataIndex: 'name'
    },
    {
      title: 'Type',
      dataIndex: 'content_type'
    },
    {
      title: 'Updated',
      dataIndex: 'updatedDate'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    }
  ]

  return columns
}
